@if (!enableNewSamplingNav) {
  <h3-sampling-controls pagePosition="header"></h3-sampling-controls>
}
<h3-input-summary *ngIf="showInputSummary$ | async"></h3-input-summary>
